import { forwardRef } from 'react';
import { useContainerClientRect } from '../../utils/hooks/useContainerClientRect.js';
import { getSlideInStyles, getSidePanelStyles } from './SidePanelStyles.js';
import { scope } from '../../providers/GigerProvider/useTheme.js';
import { jsxs, Fragment, jsx } from '@emotion/react/jsx-runtime';
import { Backdrop } from '../Backdrop/Backdrop.js';
import { SlideIn } from '../SlideIn/SlideIn.js';
import { SidebarContent } from '../SidebarContent/SidebarContent.js';
import { SlideInPosition } from '../SlideIn/types/position.js';
import { SlideInSize } from '../SlideIn/types/size.js';

const SidePanel = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    isOpen,
    children,
    header,
    footer,
    cssSlideIn,
    position = SlideInPosition.RIGHT,
    size = SlideInSize.REGULAR,
    onBackdropClick,
    includeBackdrop = true,
    containerId,
    applyBackdropToBody = true,
    fullWidthOnMobile = false,
    ...rest
  } = props;
  const containerClientRect = useContainerClientRect(containerId);
  return jsxs(Fragment, {
    children: [includeBackdrop && jsx(Backdrop, {
      isOpen: isOpen,
      onClick: onBackdropClick,
      applyToBody: applyBackdropToBody
    }), jsxs(SlideIn, {
      isOpen: isOpen,
      ref: ref,
      position: position,
      css: getSlideInStyles({
        height: containerClientRect === null || containerClientRect === void 0 ? void 0 : containerClientRect.height,
        additionalStyles: scope(cssSlideIn),
        top: containerClientRect === null || containerClientRect === void 0 ? void 0 : containerClientRect.top
      }),
      size: size,
      fullWidthOnMobile: fullWidthOnMobile,
      ...rest,
      children: [header, jsx(SidebarContent, {
        css: getSidePanelStyles,
        children: children
      }), footer]
    })]
  });
});
SidePanel.displayName = 'SidePanel';

export { SidePanel };
//# sourceMappingURL=SidePanel.js.map
